import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IContactListModel } from '@apps-common/types/management/contact'

export const MANAGEMENT_QUERY_KEY_GET_CONTACTS = (search?: string) => ['getContacts', search].filter(Boolean)

export const getContacts = async (search: string): Promise<IContactListModel[]> =>
  axios.get(`/management/contact/SearchContacts?search=${search}`).then((res) => res.data?.data)

type QueryFnType = typeof getContacts

type Props = {
  config?: QueryConfig<QueryFnType>
  search: string | undefined
}

export const useManagementGetContacts = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_CONTACTS(search),
    queryFn: () => getContacts(search || '')
  })
